import { Tables } from '@willie/supabase'
import Sentry from '~/tools/sentry'
import { getWillieSupabaseClient } from '~/utils'

// TODO make a zod schema for incidents in the schema package, use it here and in the droughts-triggers
type Incident = Tables<'incidents'>

const INCIDENT_STATUSES = ['active', 'resolved'] as const

export const SYSTEM_INCIDENT_TYPES = ['drought', 'leak', 'budget'] as const
export type IncidentType = (typeof SYSTEM_INCIDENT_TYPES)[number]

export const listSiteIncidents = async (
  siteID: string,
  { status }: { status?: (typeof INCIDENT_STATUSES)[number] } = {}
): Promise<Incident[]> => {
  const supabase = getWillieSupabaseClient()
  const q = supabase.from('incidents').select('*').eq('site_id', siteID)
  if (status) {
    q.eq('status', status)
  }

  const { data, error } = await q

  if (error) {
    console.error('Error fetching incidents:', error)
    Sentry.captureException(error, {
      extra: { siteID, status }
    })
    throw new Error('Failed to fetch incidents')
  }

  return data
}

export const getIncidentWithUpdates = async (incidentID: string) => {
  const supabase = getWillieSupabaseClient()
  const { data, error } = await supabase
    .from('incidents')
    .select('*, notifications(*)')
    .eq('id', incidentID)
    .order('created_at', { referencedTable: 'notifications', ascending: false })
    .single()

  if (error) {
    console.error('Error fetching incident:', error)
    Sentry.captureException(error, { extra: { incidentID } })
    throw new Error('Failed to fetch incident')
  }

  return data
}
